import { GET_BLOCK_BY_DISTRICT_LIST_SETTING, GET_CLUSTER_BY_BLOCK_LIST__SETTING, GET_DISTRICT_LIST_SETTING, GET_SCHOOL_BY_CLUSTER_LIST__SETTING, GET_SETTING_DATA, REFRESH_TOKEN, UPDATE_PASSWORD, UPDATE_SETTING } from "../actions/SettingsActions";

const initialState = {// initialize states
  schools: "",
  districtList: [],
  blockList: [],
  clusterList: [],
  schoolList: [],
  updatePassword: [],
};

const SettingsReducer = function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_SETTING: {
      return { ...state, };
    }
    case GET_SETTING_DATA: { // save setting data into state
      return { ...state, schools: (action.payload) ? action.payload : "" };
    }
    case GET_DISTRICT_LIST_SETTING: { // save district data into state
      return {
        ...state,
        districtList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_BLOCK_BY_DISTRICT_LIST_SETTING: { // save block by district data into state
      return {
        ...state,
        blockList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_CLUSTER_BY_BLOCK_LIST__SETTING: { // save cluster by block data into state
      return {
        ...state,
        clusterList: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_SCHOOL_BY_CLUSTER_LIST__SETTING: { // save cluster by block data into state
      return {
        ...state,
        schoolList: action.payload.data ? action.payload.data : [],
      };
    }
    case REFRESH_TOKEN: { 
      return { ...state };
    }
    case UPDATE_PASSWORD: {
      return { 
        ...state, 
        updatePassword: action.payload.data ? action.payload.data : [],
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default SettingsReducer;
